'use client';

import Image from 'next/image';
import Link from 'next/link';
import { useEffect } from 'react';
import Vector from '../../public/logo.svg';

export default function GlobalError({ error, reset }: { error: Error; reset: () => void }) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <html>
      <body>
        <div className="flex flex-col items-center justify-center min-h-screen text-center px-4 bg-background text-white" dir="rtl">
          <div className="w-full max-w-md">
            <Image src={Vector} width={85} height={85} alt="خطا" className="mx-auto opacity-60" />
          </div>
          <h1 className="text-2xl lg:text-3xl font-bold mt-6">مشکلی پیش آمد</h1>
          <p className="text-gray-500 mt-2 text-sm">
            در دریافت اطلاعات مشکلی رخ داد. لطفاً دوباره امتحان کنید.
          </p>
          <div className="flex gap-3 mt-6">
            <button
              onClick={reset}
              className="inline-block bg-primary hover:bg-primary-700 text-white font-semibold py-2 px-6 rounded-lg transition-colors"
            >
              تلاش مجدد
            </button>
            <Link
              href="/"
              className="inline-block border border-white/20 hover:border-white/40 text-white font-semibold py-2 px-6 rounded-lg transition-colors"
            >
              بازگشت به خانه
            </Link>
          </div>
        </div>
      </body>
    </html>
  );
}
